import { InitBirthdayPicker } from '../templates/customers/loyalty-lp/BirthdayPicker';
import { GWPandLoyaltyGeoSettings } from '../globals';
import '../../styles/templates/pages/page.access.scss';
import { fireHeapInteractionWithFAQonLoyaltyPageEvent, fireHeapOpenSignInsignUpModalEvent } from '../utils/heap-events';
import { getLoyaltyBlockedStatus } from '../templates/_shared/loyaltyBlockedStatus';
import { initRenderRewardsAccessPage } from '../sections/header/Cart/components/Loyalty/RewardsAccessPage';
import { InitialUrlSearchParams, isBot } from '../utils/environment';
import { initRenderAccessHero } from '../templates/product/components/AccessHero';
import builder from '@builder.io/react';
import { IS_NATIVE_APP_CLIENT } from './helpers';
import { prependLocaleToPath } from './localization';

export const loyaltyInit = async (isDomesticPage = true) => {
  const loyaltySettings = await GWPandLoyaltyGeoSettings();
  const shouldRenderLoyalty =
    loyaltySettings.shouldRenderLoyaltyForDomestic || loyaltySettings.shouldRenderLoyaltyWidgetForINTL;
  const blockedContent = document.querySelectorAll('.loyalty-bc');
  const isBlocked = await getLoyaltyBlockedStatus();
  const urlParams = InitialUrlSearchParams;
  const countryCode = urlParams.get('setCountry');

  // Conditionally initialize birthday picker for iOS
  if (IS_NATIVE_APP_CLIENT ? countryCode === 'US' : true) {
    InitBirthdayPicker(); // Render birthday modal
  } else {
    const birthdayGift = document.querySelector('.birthday-gift');
    birthdayGift && (birthdayGift.style.display = 'none');
  }

  if (!shouldRenderLoyalty) {
    if (isDomesticPage) {
      if (window.location.pathname.includes('access')) {
        window.location.href = prependLocaleToPath('/');
      }
    } else {
      if (window.location.pathname.includes('in-access')) {
        window.location.href = prependLocaleToPath('/');
      }
    }
  } else if (isBlocked) {
    const enabledContent = document.querySelectorAll('.loyalty-generic-content');
    const accessContainer = document.querySelector('div.access-container');
    const tier = window.getCustomerInfo?.().loyalty_tier;

    enabledContent.forEach((el) => el.classList.add('show'));
    if (accessContainer && tier) {
      accessContainer.classList.remove(tier);
    }
  } else {
    if (!isBot) {
      // for iOS
      const search = IS_NATIVE_APP_CLIENT ? window.location.search : '';
      if (isDomesticPage) {
        if (loyaltySettings.shouldRenderLoyaltyWidgetForINTL) {
          window.location.href = prependLocaleToPath('/pages/in-access' + search);
        }
      } else {
        if (loyaltySettings.shouldRenderLoyaltyForDomestic) {
          window.location.href = prependLocaleToPath('/pages/access' + search);
        }
      }
    }
    initRenderAccessHero();
    initRenderRewardsAccessPage({
      hideHeadings: false,
      shouldHideRedeemButton: IS_NATIVE_APP_CLIENT,
    });
    blockedContent.forEach((item) => item.classList.remove('loyalty-bc'));
  }
};

const attachEventListenersForHeap = () => {
  const getFirstAccessCTA = document.querySelector('.lp-get-first-access');
  const getSignInCTA = document.querySelector('.lp-sign-in');
  const faqWrapper = document.querySelector('[react-render-target="access-faqs"]');

  if (getFirstAccessCTA)
    getFirstAccessCTA.addEventListener('click', (event) => {
      fireHeapOpenSignInsignUpModalEvent({
        ctaLocation: 'Loyalty Landing Page: Hero',
        ctaName: (event.target as HTMLElement)?.innerText || '',
      });
    });
  if (getSignInCTA)
    getSignInCTA.addEventListener('click', (event) => {
      fireHeapOpenSignInsignUpModalEvent({
        ctaLocation: 'Loyalty Landing Page: Hero',
        ctaName: (event.target as HTMLElement)?.innerText || '',
      });
    });
  if (faqWrapper)
    faqWrapper.addEventListener('click', (event) => {
      fireHeapInteractionWithFAQonLoyaltyPageEvent({ name: (event.target as HTMLElement).innerText || '' });
    });
};

export const runPageStartUpScripts = () => {
  handlePointsProgressCaret();
  attachEventListenersForHeap();
};

function handlePointsProgressCaret() {
  const pointsLifetime = window?.getCustomerInfo ? window.getCustomerInfo().loyalty_points_lifetime : 0;

  const tier1Limit = 300;
  const tier2Limit = 1000;
  const tier3Limit = Math.max(10000, pointsLifetime);
  let percent = 0;
  const elementProgress = document.querySelector('.alo-loyalty-access .progress-line');

  if (pointsLifetime < tier1Limit) {
    percent = (pointsLifetime * 100) / tier1Limit;
  } else if (pointsLifetime >= tier1Limit && pointsLifetime < tier2Limit) {
    percent = ((pointsLifetime - tier1Limit) * 100) / (tier2Limit - tier1Limit);
  } else if (pointsLifetime >= tier2Limit) {
    percent = ((pointsLifetime - tier2Limit) * 100) / (tier3Limit - tier2Limit);
  }

  if (elementProgress) elementProgress.style.left = percent + '%';
}

export const getHeroData = async (builderKey: string, modal: string) => {
  if (!builderKey) return null;
  await builder.init(builderKey);
  const { data } = await builder.get(modal);
  return data;
};
